/** Default dental procedure fees (₹) — hospital can override in treatment plan. */
export const DEFAULT_DENTAL_FEES = {
  'Oral examination': 300,
  'Scaling & polishing': 1200,
  'Root canal treatment (RCT)': 4500,
  'Composite filling': 1500,
  'Amalgam filling': 1000,
  'Tooth extraction': 800,
  'Crown preparation': 2500,
  'Crown cementation': 1500,
  'Implant placement': 25000,
  'Periodontal therapy': 2000,
  'Orthodontic adjustment': 800,
  'Pulp capping': 1200,
  'Pulpectomy': 3500,
  'Space maintainer': 4000,
  'Denture adjustment': 600,
};

export function feeForProcedure(name) {
  if (!name) return 0;
  const exact = DEFAULT_DENTAL_FEES[name];
  if (exact != null) return exact;
  const lower = String(name).toLowerCase();
  const hit = Object.entries(DEFAULT_DENTAL_FEES).find(([k]) => lower.includes(k.toLowerCase().slice(0, 8)));
  return hit ? hit[1] : 500;
}

export const DENTAL_CHAIRS = ['Chair 1', 'Chair 2', 'Chair 3'];

export const DENTAL_SLOT_TIMES = [
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00',
  '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00',
];
